import React, { useState } from 'react';
import { Container, ThisCard } from './styles';

import IconNivel from '~/assets/icones/IconNivel.svg';
import IconNivelB from '~/assets/icones/IconNivelB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
          cor={thisData?.cor}
        >
          <div className="card-body">
            <div className="card-text">
              <p className="descricao">#{thisData?.codigo}</p>
              <p className="titulo">{thisData?.titulo}</p>
              {thisData?.valorHora && (
                <p className="valor-hora">
                  Valor/Hora: R$ {parseFloat(thisData?.valorHora).toFixed(2)}
                </p>
              )}
            </div>
          </div>
          <div className="card">
            <img src={localStorage.getItem('tema') == 'E' ? IconNivel : IconNivelB} alt="Vazio" />
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
